import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './reducers';
import routes from './config/routes';
import AuthProvider from './providers/AuthProvider';
import './App.scss';

function App() {
  const baseName = window.location.pathname.split('/')[1]; // Tomamos el primer segmento de la URL

  return (
    <Provider store={store}>
      <AuthProvider>
        <Router basename={`/${baseName}`}>
          <Switch>
            {routes.map((route, index) => (
              <>
                <RouteWithSubRoutes key={index} {...route} />
              </>
            ))}
          </Switch>
        </Router>
      </AuthProvider>
    </Provider>
  );
}

function RouteWithSubRoutes(route) {
  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={(props) => <route.component routes={route.routes} {...props} />}
    />
  );
}

export default App;
